(function () {
  /* Dans l'éditeur de thème Shopify, on désactive les effets qui remplacent le
     curseur système : sinon la souris devient invisible et on ne peut plus
     déplacer ni sélectionner les sections. */
  var isThemeEditor = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Barre de progression façon "app premium" ---------- */
  var bar = document.createElement('div');
  bar.id = 'as-progress-bar';
  document.addEventListener('DOMContentLoaded', function () {
    document.body.appendChild(bar);
  });

  function startProgress() {
    bar.style.width = '0%';
    bar.classList.add('is-active');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bar.style.width = '78%';
      });
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    if (link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var url = link.getAttribute('href');
    if (!url || url.charAt(0) === '#' || url.indexOf('mailto:') === 0 || url.indexOf('tel:') === 0) return;
    if (link.hasAttribute('data-no-progress')) return;
    try {
      var target = new URL(url, window.location.href);
      if (target.origin !== window.location.origin) return;
      if (target.pathname === window.location.pathname && target.search === window.location.search) return;
    } catch (e) {
      return;
    }
    startProgress();
  });

  window.addEventListener('pageshow', function () {
    bar.style.width = '100%';
    window.setTimeout(function () {
      bar.classList.remove('is-active');
      bar.style.width = '0%';
    }, 250);
  });

  /* ---------- Effet magnétique sur les boutons principaux ---------- */
  if (
    !isThemeEditor &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    var selector = '.button, button.button, .product-form__submit';

    document.addEventListener(
      'mousemove',
      function (event) {
        var el = event.target.closest ? event.target.closest(selector) : null;
        if (!el) return;
        el.classList.add('as-magnetic');
        var rect = el.getBoundingClientRect();
        var relX = event.clientX - (rect.left + rect.width / 2);
        var relY = event.clientY - (rect.top + rect.height / 2);
        el.style.transform = 'translate(' + relX * 0.12 + 'px, ' + relY * 0.25 + 'px)';
      },
      { passive: true }
    );

    document.addEventListener(
      'mouseout',
      function (event) {
        var el = event.target.closest ? event.target.closest(selector) : null;
        if (!el) return;
        el.style.transform = '';
      },
      { passive: true }
    );

    /* ---------- Curseur personnalisé (jamais dans l'éditeur de thème) ---------- */
    var cursor = document.createElement('div');
    cursor.id = 'as-cursor';
    document.addEventListener('DOMContentLoaded', function () {
      document.body.appendChild(cursor);
      document.documentElement.classList.add('as-custom-cursor');
    });

    var cursorX = 0,
      cursorY = 0;
    document.addEventListener(
      'mousemove',
      function (event) {
        cursorX = event.clientX;
        cursorY = event.clientY;
        cursor.style.transform = 'translate(' + cursorX + 'px, ' + cursorY + 'px) translate(-50%, -50%)';
        cursor.classList.add('is-visible');

        var hoveredInteractive = event.target.closest
          ? event.target.closest('a, button, input, textarea, select, [role="button"]')
          : null;
        cursor.classList.toggle('is-active', !!hoveredInteractive);

        var lightZone = event.target.closest ? event.target.closest('.entry-page, [data-cursor-light]') : null;
        cursor.classList.toggle('is-light', !!lightZone);
      },
      { passive: true }
    );

    document.addEventListener('mouseleave', function () {
      cursor.classList.remove('is-visible');
    });
  }

  /* ---------- Sécurité : si l'éditeur s'ouvre après coup, on rend la souris ---------- */
  if (isThemeEditor) {
    document.addEventListener('DOMContentLoaded', function () {
      document.documentElement.classList.remove('as-custom-cursor');
      var ghost = document.getElementById('as-cursor');
      if (ghost) ghost.remove();
    });
  }

  /* ---------- Bump de l'icône panier (tous appareils) ---------- */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      var cartIcon = document.getElementById('cart-icon-bubble');
      if (!cartIcon) return;
      cartIcon.classList.remove('as-cart-bump');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('as-cart-bump');
    });
  }

  /* ---------- Fondu à l'apparition des images en lazy-load ---------- */
  function setupImageFade() {
    var lazyImages = document.querySelectorAll("img[loading='lazy']");
    lazyImages.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('as-img-skip');
        return;
      }
      img.addEventListener('load', function () {
        img.classList.add('as-img-loaded');
      });
      img.addEventListener('error', function () {
        img.classList.add('as-img-skip');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupImageFade);
  } else {
    setupImageFade();
  }

  document.addEventListener('shopify:section:load', setupImageFade);
})();
